





























import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Login extends Vue {
  username = ''
  password = ''
  usernameRules = [(v: string) => !!v || 'Username is required']
  passwordRules = [(v: string) => !!v || 'Password is required']
  valid = false
  submit() {
    this.$emit('submit', { username: this.username, password: this.password })
  }
}
